import { takeEvery } from 'redux-saga';
import {
    call,
    put,
    select
} from 'redux-saga/effects';

import { saveDefaultUrbnStore } from '../actions/bopisActions';

import {
    MISL_BRANDS
} from '../enums/mislEnums';
import { getQueryParamsUrl } from '../utils/routerUtils';
import { makeRequest } from './makeRequest';

/**
 * Make a get request to MISL for store info
 * Takes a getStores action which accepts various query params.
 * See https://urbnit.atlassian.net/wiki/display/UD/Store for details.
 * @take GET_MISL_STORE
 * @param  {function} getState Redux state function
 */
export function* getMislStore(payload, meta) {
    let state = yield select();
    const res = yield call(makeRequest, getStoreRoute(state, payload));
    const defaultStore = getDefaultStore(res);

    yield put(saveDefaultUrbnStore(defaultStore, meta));
}

export function* getMislStores(payload) {
    let state = yield select();
    return yield call(makeRequest, getStoreRoute(state, payload));
}

/**
 * Get the default store from a MISL stores response
 * @param  {object} res MISL makeRequest response
 * @return {object}     MISL store
 */
export function getDefaultStore(res) {
    if (res.results[0] && res.results[0].storeNumber) {
        return res.results[0];
    }

    return null;
}

/**
 * Get the MISL brandId for the current siteId
 * @param  {function} getState Redux state function
 * @return {string}          MISL brandId
 */
export function getMislBrandId(state) {
    return MISL_BRANDS[state.core.siteId];
}

/**
 * Get the store route info object for a makeRequest call
 * @param  {function} getState    Redux state function
 * @param  {object} queryParams Query param hash
 * @return {object}             makeRequest route info
 */
export function getStoreRoute(state, queryParams) {
    const storeQueryParams = getStoreQueryParams(state, queryParams);

    return {
        cacheTTL: 60,
        localStorage: true,
        method: 'GET',
        path: getQueryParamsUrl(`${state.core.constants.urls.misl}/stores/search`, storeQueryParams),
        reduxCache: true
    };
}

/**
 * Get the store query params by merging given query params
 * and the default query params
 * @param  {function} getState    Redux state function
 * @param  {object} queryParams Query param hash. Defaults to an emtpy object.
 * @return {object}             Query param hash
 */
export function getStoreQueryParams(state, queryParams = {}) {
    return _.merge(
        {
            brandId: getMislBrandId(state),
            urbn_key: state.core.constants.mislConfig.misl_urbn_key
        },
        queryParams
    );
}

export default [];
